//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  PRIMARY_BTN_GK,
  SECONDARY_BTN_GK,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  BOX_SHADOW_GK,
  LIGHT_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONT
import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

//IMPORT NUMBERS
import { WHATS_APP_LINK } from "../../utils/phoneNumbers";

import { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import DynamicTitle from "../../components/DynamicTitle";
import AboutCall from "../../components/AboutCall";
import HeroSection from "../../components/HeroSection";
import ComercialCards from "../../components/ComercialCards";
import LogoKA from "../../assets/logo/logo-KA.png";
import JoinUsCall from "../../components/JoinUsCall";
import LocationCall from "../../components/LocationCall";
import FooterBar from "../../components/FooterBar";
import ClientAreaCall from "../../components/ClientAreaCall";
import Obituary from "../../components/Obituary";
import RecentPosts from "../../components/RecentPostsCall";
import WarningModal from "../../components/WarningModal";
import "./Home.css";

export default function Home() {
  const [warningModalShow, setWarningModalShow] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    setWarningModalShow(true);
    ReactGA.send({
      hitType: "pageview",
      page: "/grupokrause",
      title: "Home Page Grupo Krause",
    });
  }, []);

  return (
    <div className="Home">
      <WarningModal
        show={warningModalShow}
        onHide={() => setWarningModalShow(false)}
      />
      <DynamicTitle
        pageTitle="Grupo Krause"
        pageMeta="Grupo Krause"
        pageContent="Cuidar em Vida e Eternizar Histórias. O Grupo Krause é formado por 4 marcas que juntas oferecem um dos mais completos pacotes de serviços funerários do Rio Grande do Sul. Presente na vida de milhares de famílias e seus Pets, oferecendo vantagens e proteção em vida através do Plano Assistencial Grupo Krause e Rede de Vantagem Krause."
      />
      <HeroSection />
      <AboutCall
        white={WHITE}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        btnColor={PRIMARY_BTN_GK}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
      />
      <ComercialCards
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        comercialIcon={LogoKA}
        titleColor={TITLE_COLOR_GK}
        subTitleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        shadowColor={BOX_SHADOW_GK}
        btnColor={PRIMARY_BTN_GK}
        textTop={220}
        whatsAppNumber={WHATS_APP_LINK}
      />
      <ClientAreaCall
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        btnColor={PRIMARY_BTN_GK}
        autoCarosel={true}
      />
      <Obituary
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        secondaryBtnColor={SECONDARY_BTN_GK}
        primaryBtnColor={PRIMARY_BTN_GK}
        funeralDistanciaCall={true}
      />
      <RecentPosts
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        btnColor={PRIMARY_BTN_GK}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        subTextSize={SUB_TEXT_SIZE}
      />
      <LocationCall
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        fadeBG={FADE_BG_GK}
      />
      <JoinUsCall
        white={WHITE}
        iconColor={ICON_COLOR_GK}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        textSize={TEXT_SIZE}
        fadeBG={FADE_BG_GK}
        circleBG={LIGHT_BG_GK}
        btnColor={PRIMARY_BTN_GK}
      />
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
